<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<p class="SP"> </p>
<p class="FM-Epigraph-non-verse-fmepi"><span epub:type="pagebreak" id="pg_vii" title="vii">As the surgeon’s scalpel reveals my organs, love introduces other versions of myself, whose obscene novelty disgusts me.</span></p>
<p class="FM-Epigraph-Source-fmeps">—<span class="fm-epigraph-source-fmeps-_span-accent-characters-acc-_CAPS">É</span><span class="ePub-SC">DOUARD</span> <span class="fm-epigraph-source-fmeps-_CAPS">L</span><span class="ePub-SC">EVÉ</span><span class="ePub-SC">,</span> <span class="ePub-I">Autoportrait</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?400d836e